module.exports = __webpack_public_path__ + "static/media/citrics-min.86178125.png";